import {Model} from "../decorators/model.decorator";
import {Column} from "../decorators/column.decorator";
import {BaseModel} from "./base.model";

@Model('measure')
export class Measure extends BaseModel {
  @Column()
  id: number | undefined;
  @Column()
  width: number | undefined;
  @Column()
  height: number | undefined;
}
